/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取会员成长任务
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.GrowthTaskDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/level/growth-task`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
